declare const APP_NAME: string;
declare const APP_VERSION: string;

export default defineNuxtPlugin({
  name: 'Sentry',
  parallel: true,

  async setup({ vueApp }) {
    const Sentry = (await import('@sentry/vue'));

    const { public: { sentryDsn }, app: { environment } } = useRuntimeConfig();

    if (!sentryDsn) {
      // eslint-disable-next-line no-console
      console.warn('[Sentry]: Missing DSN config.');
      return;
    }

    const router = useRouter();

    Sentry.init({
      app: vueApp,
      dsn: sentryDsn,
      environment,
      release: `${APP_NAME}@${APP_VERSION}`,
      integrations: [
        new Sentry.BrowserTracing({
          routingInstrumentation: Sentry.vueRouterInstrumentation(router),
        }),
        new Sentry.Replay({
          maskAllInputs: true,
          maskAllText: false,
          blockAllMedia: false,
        }),
        // new Sentry.Feedback({
        //   // Additional SDK configuration goes in here, for example:
        //   colorScheme: 'light',
        //   showName: false,
        //   isEmailRequired: true,
        //   buttonLabel: 'Nahlásit chybu'
        // }),
      ],
      tracesSampleRate: 0.2,
      tracePropagationTargets: ['localhost', 'dluhopisomat.cz', 'test.dluhopisomat.cz'],
      replaysSessionSampleRate: 1.0,
      replaysOnErrorSampleRate: 1.0,
    });
  }
});
